import { listChanges } from './changes';
import { validateEventsArray } from './utils';
import 'rxjs/add/operator/map';
export function snapshotChanges(query, events) {
    events = validateEventsArray(events);
    return listChanges(query, events);
}
//# sourceMappingURL=snapshot-changes.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angularfire2/database/list/snapshot-changes.js
// module id = ../../../../angularfire2/database/list/snapshot-changes.js
// module chunks = 7